import { render, staticRenderFns } from "./department-item.vue?vue&type=template&id=a64ee21c&scoped=true"
import script from "./department-item.vue?vue&type=script&lang=js"
export * from "./department-item.vue?vue&type=script&lang=js"
import style0 from "./department-item.vue?vue&type=style&index=0&id=a64ee21c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64ee21c",
  null
  
)

export default component.exports